import { useEffect, useState } from "react";
import { FilesDocDTO, NodoDocDTO, Peru9112WinENTITY } from "sigo-entities";
import { AdjuntosV1 } from "../../shared/Components/AdjuntosV1/Adjuntos";
import { Row } from "react-bootstrap";
import { FTPService } from "../../shared/Infraestructure/AdapterFileSystem";
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico";
import { useUploadPhotosWINOrdersMutation } from "../../shared/Infraestructure/slice";

interface Props {
    row: Peru9112WinENTITY
}

export function Adjuntos({ row }: Props) {
    const [nodos, setNodos] = useState<NodoDocDTO[]>([])
    const [newFiles, setNewFiles] = useState<File[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [uploadPhotosWINOrders, { isLoading }] = useUploadPhotosWINOrdersMutation()
    const ruta = `ORDENES_WIN_${row._id.replaceAll('-', '').toUpperCase()}_PHOTOS_`
    const Extension = ['pdf', 'png', 'jpg', 'jpeg']
    const Size = {
        Size: 50,
        UM: 'mb'
    }
    const Estado = {
        ID_Estado: 1,
        Nombre: 'ACTIVO'
    }
    const documentacion: NodoDocDTO[] = [
        {
            Titulo: 'BOLETIN',
            Codigo: 'Cod1',
            Descripcion: 'BOLETIN',
            Files: [],
            Extension,
            Size,
            Requerido: true,
            CantidadMin: 1,
            CantidadMax: 1,
            Children: [],
            Estado,
            label: 'BOLETIN',
            id: 1
        }
    ]

    const restoreFiles = (documentacion: NodoDocDTO[]) => {
        for (const nodo of documentacion) {
            const files = [row.boletin].filter(e => e.CodigoNodo === nodo.Codigo)
            nodo.Files = files
            restoreFiles(nodo.Children)
        }
    }

    useEffect(() => {
        if (row) {
            restoreFiles(documentacion)
            setNodos(documentacion)
        }
    }, [row])

    function getAnexos(nodos: NodoDocDTO[]): FilesDocDTO[] {
        return nodos.reduce((acc: FilesDocDTO[], nodo) => {
            return [...acc, ...nodo.Files.filter(e => e.Estado.ID_Estado === 1), ...getAnexos(nodo.Children)]
        }, [])
    }

    const savePhotos = async () => {
        try {
            setLoading(true)
            for await (const file of newFiles) {
                await FTPService.setFileToServer(file.name, file)
            }
            setLoading(false)
            let boletin: FilesDocDTO = new FilesDocDTO()
            const anexos = getAnexos(nodos)
            boletin = anexos.length ? anexos[0] : new FilesDocDTO()

            if (boletin.Posicion !== row.boletin.Posicion) {
                await uploadPhotosWINOrders({ boletin, id: row._id }).unwrap()
                AdapterGenerico.createMessage('Alerta', 'Se ha actualizado el boletin correctamente', 'success')
            }
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Row className='mt-4'>
            <AdjuntosV1
                Nodos={nodos}
                setNodos={setNodos}
                ruta={ruta}
                newFiles={newFiles}
                setNewFiles={setNewFiles}
                onSave={savePhotos}
                loading={loading || isLoading}
            />
        </Row>
    )
}